import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { SubscriptionTypesComponent } from './subscription-types/subscription-types.component';
import { OperatorComponent } from '../operator/operator.component';
import { AuthGuard } from '@guards/auth/auth.guard';
import { RoleGuard } from '@guards/role/role.guard';
import { ChargingStationProfilesComponent } from './chargingstationprofiles/chargingstationprofiles.component';
import { CreateManufacturerDialogComponent } from '@components/dialog/create-manufacturer-dialog/create-manufacturer-dialog.component'
import { StatusNotificationsTableComponent } from './statusnotifications/statusnotifications.component';
import { CreateChargingStationDialogComponent } from '../dialog/create-charging-station-dialog/create-charging-station-dialog.component';
import { MassCreateChargingStationDialogComponent } from '../dialog/mass-create-charging-station-dialog/mass-create-charging-station-dialog.component';
import { DeleteChargingStationDialogComponent } from '../dialog/delete-charging-station-dialog/delete-charging-station-dialog.component';
import { EditChargingstationprofilesComponent } from './chargingstationprofiles/edit-chargingstationprofiles/edit-chargingstationprofiles.component';
import { DeleteChargingstationprofilesComponent } from './chargingstationprofiles/delete-chargingstationprofiles/delete-chargingstationprofiles.component';
import { DetailsChargingStationDialogComponent } from '@components/dialog/details-charging-station-dialog/details-charging-station-dialog.component';
import { UsersComponent } from '@components/entities/users/users.component';
import { UsersTableComponent } from '@components/entities/users/users-table/users-table.component';
import { DashboardOfflineSinceComponent } from '@components/operator/dashboard-offlineSince/dashboard-offlineSince.component'
import { RegisterUserFromOperatorComponent } from './register-user-operator/register-user-operator.component';
import { CustomersTableComponent } from '../entities/customers/customers-table/customers-table.component';
import { CreateCustomerDialogComponent } from '../dialog/create-customer-dialog/create-customer-dialog.component';
import { CustomerOverviewComponent } from '../entities/customers/customer-overview/customer-overview.component';
import { ChargingStationsTableComponent } from '../entities/charging-stations/charging-stations-table/charging-stations-table.component';
import { EditUserDialogComponent } from '../dialog/edit-user-dialog/edit-user-dialog.component';
import { PaymentReceiptsComponent } from '../entities/payment-receipts/payment-receipts.component';
import { CustomerHistoryComponent } from '../entities/customers/customer-history/customer-history.component';
import { CustomerPermissionsComponent } from '../entities/customers/customer-permissions/customer-permissions.component';
import { ProfileComponent } from '../manage/profile/profile.component';
import { DeliveryNoteSettings } from '@models/deliveryNotes';
import { DeliveryNoteActionsDialogComponent } from '../dialog/delivery-note-actions-dialog/delivery-note-actions-dialog.component';
import { DeliveryNotesComponent } from '../evaluation/delivery-notes/delivery-notes.component';
import { ChargingStatisticsComponent } from '../evaluation/charging-statistics/charging-statistics.component';
import { DetailsTransactionDialogComponent } from '../dialog/details-transaction-dialog/details-transaction-dialog.component';
import { TransactionsComponent } from '../evaluation/transactions/transactions.component';
import { ChargingStationsStatusHistoryTableComponent } from '../entities/charging-stations/charging-stations-status-history-table/charging-stations-status-history-table.component';
import { CreateUserDialogComponent } from '../dialog/create-user-dialog/create-user-dialog.component';
import { RfidCardsTableComponent } from '../entities/rfid-cards/rfid-cards-table/rfid-cards-table.component';
import { CreateRfidCardDialogComponent } from '../dialog/create-rfid-card-dialog/create-rfid-card-dialog.component';
import { EditRfidCardDialogComponent } from '../dialog/edit-rfid-card-dialog/edit-rfid-card-dialog.component';
import { DeleteGroupDialogComponent } from '../dialog/delete-group-dialog/delete-group-dialog.component';
import { EditGroupDialogComponent } from '../dialog/edit-group-dialog/edit-group-dialog.component';
import { GroupsComponent } from '../manage/groups/groups.component';
import { EditInvoiceSettingsDialogComponent } from '../dialog/edit-invoice-settings-dialog/edit-invoice-settings-dialog.component';
import { PrintInvoiceDialogComponent } from '../dialog/print-invoice-dialog/print-invoice-dialog.component';
import { CreateInvoiceDialogComponent } from '../dialog/create-invoice-dialog/create-invoice-dialog.component';
import { InvoicesComponent } from '../entities/invoices/invoices.component';
import { EditPricingDialogComponent } from '../dialog/edit-pricing-dialog/edit-pricing-dialog.component';
import { CreatePricingDialogComponent } from '../dialog/create-pricing-dialog/create-pricing-dialog.component';
import { PricingsComponent } from '../entities/pricings/pricings.component';
import { UnassignedRfidCardsTableComponent } from '@components/entities/rfid-cards/unassigned-rfid-cards-table/unassigned-rfid-cards-table.component';
import { DashboardComponent } from '@components/dashboard/dashboard.component';
import { EditDeliveryNotesSettingsDialogComponent } from '@components/dialog/edit-delivery-notes-settings-dialog/edit-delivery-notes-settings-dialog.component';
import { DeletePricingDialogComponent } from '../dialog/delete-pricing-dialog/delete-pricing-dialog.component';
import { PayoutStatementsDialogComponent } from '@components/dialog/payout-statements-dialog/payout-statements-dialog.component';
import { ManufacturerTableComponent } from './manufacturer/manufacturer.component';
import { CreateChargingStationProfileDialogComponent } from '../dialog/create-chargingstationprofile-dialog/create-chargingstationprofile-dialog.component';
import { RemovePricingDialogContentComponent } from '@components/dialog/remove-pricing-dialog/remove-pricing-dialog-content/remove-pricing-dialog-content.component';
import { EnergyMonitorComponent } from '@components/energy/energy-monitor/energy-monitor.component';
import { CreateManufacturerComponent } from '../entities/manufacturer/create-manufacturer/create-manufacturer.component';
import { EditChargingStationProfileDialogComponent } from '../dialog/edit-chargingstationprofiles-dialog/edit-chargingstationprofile-dialog.component';
import { EditChargingstationProfileDialogContentComponent } from '../dialog/edit-chargingstationprofiles-dialog/edit-chargingstationprofile-dialog-content/edit-chargingstationprofile-dialog-content.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { EnergyTabNavigationComponent } from '@components/energy/energy-monitor/energy-tab-navigation/energy-tab-navigation.component';
import { BidiChargingComponent } from '@components/energy/bidi-charging/bidi-charging.component';



@NgModule({
  declarations: [
    EditChargingstationprofilesComponent,
    EditChargingStationProfileDialogComponent,
    EditChargingstationProfileDialogContentComponent,
    DeleteChargingstationprofilesComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule.forChild(
      [
        {
          path: 'operator',
          component: OperatorComponent,
          canActivate: [AuthGuard, RoleGuard],
          data: {
            isOperatorView: true,
            roles: ['Operator'],
            showAll: true
          },
          children: [
            {
              path: 'chargingstation/:key',
              component: DetailsChargingStationDialogComponent
            },
            {
              path: ':key',
              component: DetailsTransactionDialogComponent,
              data: { isOperatorView: true },
              
            }
          ],
        },
        {
          path: 'subscription-types',
          component: SubscriptionTypesComponent,
          canActivate: [AuthGuard, RoleGuard],
          data: {
            roles: ['Operator']
          }
        },
        {
          path: 'csprofiles',
          component: ChargingStationProfilesComponent,
          canActivate: [AuthGuard, RoleGuard],
          data: {
            isOperatorView: true,
            roles: ['Operator'],
            showAll: true
          },
          children: [
            {
              path: 'create',
              component: CreateChargingStationProfileDialogComponent,
            },
            {
              path: 'edit/:key',
              component: EditChargingStationProfileDialogComponent,
              children: [
                {
                  path: 'delete',
                  component: DeleteChargingstationprofilesComponent
                }
              ]
            }
          ],
        },
        {
          path: 'statusnotifications',
          component: StatusNotificationsTableComponent,
          canActivate: [AuthGuard, RoleGuard],
          data: {
            isOperatorView: true,
            roles: ['Operator'],
            showAll: true
          },
          children: [
            {
              path: 'chargingstation/:key',
              component: DetailsChargingStationDialogComponent
            }],
        },
        {
          path: 'users', component: UsersComponent, canActivate: [AuthGuard, RoleGuard], data: { roles: ['Operator'], showAll: true }, children: [
            {
              path: '',
              component: UsersTableComponent,
              data: { roles: ['Operator'], showAll: true, isUserProfile: true},
            },
          ]
        },
        {
          path: 'manufacturer',
          component: ManufacturerTableComponent,
          canActivate: [AuthGuard, RoleGuard],
          data: {
            isOperatorView: true,
            roles: ['Operator'],
            showAll: true
          },
          children: [
            {
            path: 'create',
              component: CreateManufacturerDialogComponent
            },

            {
              path: 'edit/:key',
              component: CreateManufacturerDialogComponent
            }
          ]
        },
        {
          path: 'customer',
          component: CustomersTableComponent,
          canActivate: [AuthGuard, RoleGuard],
          data: { roles: ['Operator'], showAll: true, isOperatorView: true }, children: [
            {
              path: 'register',
              component: CreateCustomerDialogComponent,
              data: { roles: ['Operator'], showAll: true, isOperatorView: true },
            },
          ]
        },
        {
          path: 'customer/:key', component: CustomerOverviewComponent, canActivate: [AuthGuard, RoleGuard], data: { roles: ['Operator'] }, children: [
            {
              path: '',
              redirectTo: 'dashboard',
              pathMatch: 'full'
            },
            {
              path: 'dashboard',
              component: DashboardComponent,
              data: { isOperatorView: true }
            },
            {
              path: 'users',
              component: UsersTableComponent,
              data: { isOperatorView: true },
              children: [
                {
                  path: 'edit/:key',
                  component: EditUserDialogComponent
                },
                {
                  path: 'create',
                  component: CreateUserDialogComponent
                },
              ]
            },
            {
              path: 'rfid',
              component: RfidCardsTableComponent,
              data: { isOperatorView: true },
              children: [
                {
                  path: 'create',
                  component: CreateRfidCardDialogComponent
                },
                {
                  path: 'edit/:key',
                  component: EditRfidCardDialogComponent
                }
              ]
            },
            {
              path: 'unassigned-rfid',
              component: UnassignedRfidCardsTableComponent,
              data: { isOperatorView: true },
              children: [
                {
                  path: 'create',
                  component: CreateRfidCardDialogComponent
                },
                {
                  path: 'edit/:key',
                  component: EditRfidCardDialogComponent
                }
              ]
            },
            {
              path: 'pricings',
              component: PricingsComponent,
              data: {
                roles: ['Operator'],
                isOperatorView: true
              },
              children: [
                {
                  path: 'create',
                  component: CreatePricingDialogComponent,
                },
                {
                  path: 'edit/:key',
                  component: EditPricingDialogComponent,
                },
                {
                  path: 'delete/:key',
                  component: DeletePricingDialogComponent,
                },
                {
                  path: 'remove-users',
                  component: RemovePricingDialogContentComponent,
                },
              ]
            },
            {
              path: 'invoices',
              component: InvoicesComponent,
              data: {
                isOperatorView: true,
                roles: ['Operator']
              },
              children: [
                {
                  path: 'create/:key',
                  component: CreateInvoiceDialogComponent,
                  data: { roles: ['Operator'] },
                },
                {
                  path: 'print/:key',
                  component: PrintInvoiceDialogComponent,
                  data: { roles: ['Operator'] },
                },
                {
                  path: 'settings',
                  component: EditInvoiceSettingsDialogComponent,
                  data: { roles: ['Operator'] },
                },
                {
                  path: 'payout-statements',
                  component: PayoutStatementsDialogComponent,
                  data: { roles: ['Operator'] },
                },
              ]
            },
            {
              path: 'groups',
              component: GroupsComponent,
              data: { isOperatorView: true },
              children: [
                {
                  path: 'edit/:key',
                  component: EditGroupDialogComponent,
                },
                {
                  path: 'delete/:key',
                  component: DeleteGroupDialogComponent
                }
              ]
            },
            {
              path: 'chargingstations-status-log',
              component: ChargingStationsStatusHistoryTableComponent,
              children: [
                {
                  path: 'edit/:key',
                  component: DetailsChargingStationDialogComponent
                },
              ]
            },
            {
              path: 'transactions',
              component: TransactionsComponent,
              data: { isOperatorView: true },
              children: [
                {
                  path: ':key',
                  component: DetailsTransactionDialogComponent,
                }
              ]
            },
            {
              path: 'chargingstations',
              component: ChargingStationsTableComponent,
              data: { isOperatorView: true },
              children: [
                {
                  path: 'create',
                  component: CreateChargingStationDialogComponent
                },
                {
                  path: 'mass-create',
                  component: MassCreateChargingStationDialogComponent
                },
                {
                  path: 'edit/:key',
                  component: DetailsChargingStationDialogComponent
                },
                {
                  path: 'delete/:key',
                  component: DeleteChargingStationDialogComponent
                }
              ]
            },
            {
              path: 'charging-statistics',
              component: ChargingStatisticsComponent,
              data: { isOperatorView: true }
            },
            {
              path: 'delivery-notes',
              component: DeliveryNotesComponent,
              data: { isOperatorView: true },
              children: [
                {
                  path: 'edit/:key',
                  component: DeliveryNoteActionsDialogComponent,
                  data: { isOperatorView: true },
                },
                {
                  path: 'settings',
                  component: EditDeliveryNotesSettingsDialogComponent,
                  data: { isOperatorView: true },
                }
              ]
            },
            {
              path: 'profile',
              component: ProfileComponent,
              data: { isOperatorView: true }
            },
            {
              path: 'energy-monitor',
              component: EnergyMonitorComponent,
              data: { isOperatorView: true }
            },
            {
              path: 'bidi-charging',
              component: BidiChargingComponent,
              data: { isOperatorView: true }
            },
            {
              path: 'energy',
              component: EnergyTabNavigationComponent,
              data: { isOperatorView: true }
            },
            {
              path: 'permissions',
              component: CustomerPermissionsComponent
            },
            {
              path: 'history',
              component: CustomerHistoryComponent
            },
            {
              path: 'payment-receipts',
              component: PaymentReceiptsComponent,
              data: { isOperatorView: true }
            },
          ]
        },
        {
          path: 'pool/:key', component: CustomerOverviewComponent, canActivate: [AuthGuard, RoleGuard], data: { isProduction:true, roles: ['Operator'] }, children: [
            {
              path: '',
              redirectTo: 'chargingstations',
              pathMatch: 'full'
            },

            {
              path: 'users',
              component: UsersTableComponent,
              data: { isOperatorView: true },
              children: [
                {
                  path: 'edit/:key',
                  component: EditUserDialogComponent
                },
                {
                  path: 'create',
                  component: CreateUserDialogComponent
                },
              ]
            },
            {
              path: 'rfid',
              component: RfidCardsTableComponent,
              data: { isOperatorView: true },
              children: [
                {
                  path: 'create',
                  component: CreateRfidCardDialogComponent
                },
                {
                  path: 'edit/:key',
                  component: EditRfidCardDialogComponent
                }
              ]
            },
            {
              path: 'unassigned-rfid',
              component: UnassignedRfidCardsTableComponent,
              data: { isOperatorView: true },
              children: [
                {
                  path: 'create',
                  component: CreateRfidCardDialogComponent
                },
                {
                  path: 'edit/:key',
                  component: EditRfidCardDialogComponent
                }
              ]
            },
            {
              path: 'pricings',
              component: PricingsComponent,
              data: {
                roles: ['Operator'],
                isOperatorView: true
              },
              children: [
                {
                  path: 'create',
                  component: CreatePricingDialogComponent,
                },
                {
                  path: 'edit/:key',
                  component: EditPricingDialogComponent,
                },
              ]
            },
            {
              path: 'invoices',
              component: InvoicesComponent,
              data: {
                isOperatorView: true,
                roles: ['Operator']
              },
              children: [
                {
                  path: 'create/:key',
                  component: CreateInvoiceDialogComponent,
                  data: { roles: ['Operator'] },
                },
                {
                  path: 'print/:key',
                  component: PrintInvoiceDialogComponent,
                  data: { roles: ['Operator'] },
                },
                {
                  path: 'settings',
                  component: EditInvoiceSettingsDialogComponent,
                  data: { roles: ['Operator'] },
                },
              ]
            },
            {
              path: 'groups',
              component: GroupsComponent,
              data: { isOperatorView: true },
              children: [
                {
                  path: 'edit/:key',
                  component: EditGroupDialogComponent,
                },
                {
                  path: 'delete/:key',
                  component: DeleteGroupDialogComponent
                }
              ]
            },
            {
              path: 'chargingstations-status-log',
              component: ChargingStationsStatusHistoryTableComponent,
              children: [
                {
                  path: 'edit/:key',
                  component: DetailsChargingStationDialogComponent
                },
              ]
            },
            {
              path: 'transactions',
              component: TransactionsComponent,
              data: { isOperatorView: true },
              children: [
                {
                  path: ':key',
                  component: DetailsTransactionDialogComponent,
                }
              ]
            },
            {
              path: 'chargingstations',
              component: ChargingStationsTableComponent,
              data: { isOperatorView: true },
              children: [
                {
                  path: 'create',
                  component: CreateChargingStationDialogComponent
                },
                {
                  path: 'edit/:key',
                  component: DetailsChargingStationDialogComponent
                },
                {
                  path: 'delete/:key',
                  component: DeleteChargingStationDialogComponent
                }
              ]
            },
            {
              path: 'charging-statistics',
              component: ChargingStatisticsComponent,
              data: { isOperatorView: true }
            },
            {
              path: 'delivery-notes',
              component: DeliveryNotesComponent,
              data: { isOperatorView: true },
              children: [
                {
                  path: 'edit/:key',
                  component: DeliveryNoteActionsDialogComponent,
                  data: { isOperatorView: true },
                },
                {
                  path: 'settings',
                  component: DeliveryNoteSettings,
                  data: { isOperatorView: true },
                }
              ]
            },
            {
              path: 'profile',
              component: ProfileComponent,
              data: { isOperatorView: true }
            },
            {
              path: 'permissions',
              component: CustomerPermissionsComponent
            },
            {
              path: 'history',
              component: CustomerHistoryComponent
            },
            {
              path: 'payment-receipts',
              component: PaymentReceiptsComponent,
              data: { isOperatorView: true }
            },
          ]
        }
       
        ],
    )
  ],
  providers: [
  ],
})
export class OperatorModule { }
